import {
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonHeader,
  IonRow,
  IonToolbar,
} from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import type { ReactNode } from 'react'
import { useOrganization } from '../hooks/useOrganization'

export type GreetingHeaderProps = {
  name?: string
  subtitle?: ReactNode
}

export const GreetingHeader = (props: GreetingHeaderProps) => {
  const { organization } = useOrganization()
  const { _ } = useLingui()
  const logo = organization?.logo

  return (
    <IonHeader mode='ios' className='greeting-header'>
      <IonToolbar>
        <IonRow className='ion-padding' style={{ paddingBottom: '4px' }}>
          <IonCol>
            <IonCardTitle
              style={{ marginBottom: '5px' }}
              data-testid='greeting-title'
            >
              {_(msg`Hello`)}{' '}
              <span
                style={{
                  fontWeight: 400,
                  color: 'var(--cs-name-color)',
                }}
              >
                {props.name}
              </span>
            </IonCardTitle>
            <IonCardSubtitle>{props.subtitle || ' '}</IonCardSubtitle>
          </IonCol>
          <IonCol size='auto'>
            {logo ? (
              <img
                src={logo}
                alt={organization?.name}
                width='45'
                className='greeting-header__logo'
              />
            ) : (
              <img
                src='/assets/cs-logo.svg'
                alt='CreteSuite'
                width='45'
                height='45'
                className='greeting-header__logo'
              />
            )}
          </IonCol>
        </IonRow>
      </IonToolbar>
    </IonHeader>
  )
}
